module.exports = __webpack_public_path__ + "img/healthcare.d63085bc.svg";